import { createContext } from 'react';

const WarnUserContext = createContext({});

export default WarnUserContext;
